export default abstract class Builder<T1, T2 = null> {
    protected built: T1;
    protected parent: T2;
    
    protected constructor(parent?: T2) {
        this.parent = parent;
    }

    public done(): T2 {
        return this.parent;
    }

    protected abstract buildInternal(): T1;

    protected abstract preBuild(): void;

    protected getBuild(): T1 {
        return this.built;
    }

    public build(): T1 {
        if (this.built != null)
            throw new Error("Builder was already built.")

        this.preBuild();
        this.built = this.buildInternal();
        return this.built;
    }
}